<template>
  <el-dialog
    :title="model.id > 0 ? '编辑维修记录' : '添加维修记录'"
    :visible.sync="visible"
    width="600px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <el-form
      ref="form"
      size="small"
      label-width="110px"
      :model="model"
      :rules="rules"
    >
      <el-form-item label="维修日期" prop="used_date">
        <el-date-picker
          class="long"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          }"
          v-model="model.used_date"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="使用次数" prop="usage">
        <el-select v-model="model.usage" class="long">
          <el-option
            :key="n"
            :value="n"
            v-for="n in 30"
            :label="`第${n}次`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="维修更换情况" class="long">
        <el-input v-model="model.inspection" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="处理措施和结果" class="long">
        <el-input v-model="model.solution" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="备注" class="long">
        <el-input v-model="model.remark" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="图片" class="long">
        <FileUpload v-model="model.imgs" v-if="visible"></FileUpload>
      </el-form-item>
      <el-form-item label="视频" class="long">
        <VideoUploader v-model="model.videos" v-if="visible"></VideoUploader>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确认</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { productRecordNew, productRecordUpdate } from '@/service/getData'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      submiting: false,
      rules: {
        used_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
        // usage: [{ required: true, message: '请选择使用次数', trigger: 'blur' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true

          let isUpdate = this.model.id > 0
          let res = {}
          if (isUpdate) {
            res = await productRecordUpdate(this.model)
          } else {
            res = await productRecordNew(this.model)
          }

          if (res.code == 0) {
            this.$emit(`${isUpdate ? 'updated' : 'created'}`, res.data)
            this.submiting = false
            this.visible = false
          }
        }
      })
    },
  },
}
</script>